<template>
  <div class="menu-main">
    <el-menu
        class="el-menu-vertical-demo"
        :collapse="getIsOpenCloseManu"
        background-color="#f8fbff"
        text-color="#5f6f8f"
        active-text-color="#2f436d"
        :unique-opened="true"
        :default-active="activeMenuIndex"
        :default-openeds="openSubMenu"
        @select="handleMenuSelect"
    >
      <router-link to="/dashboard" class="router-link">
        <el-menu-item index="1" class="menu-logo-item">
          <i class="el-icon-s-home menu-logo-icon"></i>
          <span slot="title" class="onekids-title">SUPPER PLUS</span>
        </el-menu-item>
      </router-link>
      <el-submenu index="2" class="menu-group-staff">
        <template #title>
          <i class="el-icon-user"/>
          <span>Quản lý nhân sự</span>
        </template>
        <router-link to="/employee/employees-plus" class="router-link">
          <el-menu-item
              index="2-1"
              @click="changeBreadcrumbMethod('employee-employees-plus')"
          >Quản lý Plus
          </el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="3" class="menu-group-config">
        <template #title>
          <i class="el-icon-setting"/>
          <span>Cấu hình nhà trường</span>
        </template>
        <router-link to="/school/config" class="router-link">
          <el-menu-item
              index="3-1"
              @click="changeBreadcrumbMethod('school-config')"
          >Cấu hình chung
          </el-menu-item>
        </router-link>
<!--        <router-link to="/school/configNew" class="router-link">-->
<!--          <el-menu-item-->
<!--              index="3-100"-->
<!--              @click="changeBreadcrumbMethod('school/configNew')"-->
<!--          >Cấu hình chung (Mới)-->
<!--          </el-menu-item>-->
<!--        </router-link>-->
        <router-link to="/school/camera" class="router-link">
          <el-menu-item
              index="3-2"
              @click="changeBreadcrumbMethod('school-camera')"
          >Cấu hình Camera
          </el-menu-item>
        </router-link>
        <router-link to="/school/media" class="router-link">
          <el-menu-item
              index="3-3"
              @click="changeBreadcrumbMethod('school-media')"
          >Cấu hình Media
          </el-menu-item>
        </router-link>

        <router-link to="/school/birthday-sample" class="router-link">
          <el-menu-item
              index="3-4"
              @click="changeBreadcrumbMethod('school-birthday-sample')"
          >Cấu hình gửi tin
          </el-menu-item>
        </router-link>
        <router-link to="/school/notification-manage" class="router-link">
          <el-menu-item
              index="3-5"
              @click="changeBreadcrumbMethod('school-notification-manage')"
          >Tự động gửi tin
          </el-menu-item>
        </router-link>
        <router-link to="/school/config-fuction" class="router-link">
          <el-menu-item
              index="3-6"
              @click="changeBreadcrumbMethod('school-config-fuction')"
          >Ẩn hiển chức năng
          </el-menu-item>
        </router-link>
        <router-link to="/school/permission-manage" class="router-link">
          <el-menu-item
              index="3-7"
              @click="changeBreadcrumbMethod('school-permission-manage')"
          >Quản lý quyền
          </el-menu-item>
        </router-link>
<!--          Thêm cấu hình đểm danh chủ nhật-->
        <router-link to="/school/permission-manage-for-supperPlus" class="router-link">
          <el-menu-item
              index="3-8"
              @click="changeBreadcrumbMethod('school-permission-manage-for-supperPlus')"
          >Tạo dữ liệu chung
          </el-menu-item>
        </router-link>


<!--        Thêm cấu hình Template App cho trường-->
        <router-link to="/school/config-template-app" class="router-link">
          <el-menu-item
              index="3-9"
              @click="changeBreadcrumbMethod('config-template-app')"
          >Thiết lập giao diện
          </el-menu-item>
        </router-link>

        <router-link to="/school/config-ticket-app" class="router-link">
          <el-menu-item
              index="3-10"
              @click="changeBreadcrumbMethod('config-ticket-app')"
          >Thiết lập phiếu bé ngoan
          </el-menu-item>
        </router-link>

        <router-link to="/school/config-chat" class="router-link">
          <el-menu-item
              index="3-11"
              @click="changeBreadcrumbMethod('config-chat')"
          >Cấu hình chat
          </el-menu-item>
        </router-link>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "MenuSuperSchool",
  data() {
    return {
      supportList: [],
      breadcrumbDataList: [
        //quản lý nhân sự plus
        {
          key: "employee-employees-plus",
          value: [{url: "/employee/employees-plus", name: "Quản lý Plus"}],
        },
        {
          key: "school-config",
          value: [{url: "/school/config", name: "Cấu hình chung"}],
        },
        // {
        //   key: "school/configNew",
        //   value: [{url: "school/configNew", name: "Cấu hình chung(mới)"}],
        // },
        {
          key: "school-camera",
          value: [{url: "/school/camera", name: "Cấu hình Camera"}],
        },
        {
          key: "school-media",
          value: [{url: "/school/media", name: "Cấu hình Media"}],
        },
        {
          key: "school-birthday-sample",
          value: [{url: "/school/birthday-sample", name: "Cấu hình gửi tin"}],
        },
        {
          key: "school-notification-manage",
          value: [{url: "/school/notification-manage", name: "Tự động gửi tin"}],
        },
        {
          key: "school-config-fuction",
          value: [{url: "/school/config-fuction", name: "Ẩn hiển chức năng"}],
        },
        {
          key: "school-permission-manage",
          value: [{url: "/school/permission-manage", name: "Quản lý quyền"}],
        },
        {
          key: "school-permission-manage-for-supperPlus",
          value: [{url: "/school/permission-manage-for-supperPlus", name: "Tạo dữ liệu chung"}],
        },

        {
          key: "config-template-app",
          value: [{url: "/school/config-template-app", name: "Cấu hình Template App"}],
        },
        {
          key: "config-ticket-app",
          value: [{url: "/school/config-ticket-app", name: "Cấu hình Ticket App"}],
        },

        {
          key: "config-chat",
          value: [{url: "/school/config-chat", name: "Cấu hình chat"}],
        },
      ]

    };
  },
  computed: {
    getIsOpenCloseManu() {
      return this.$store.getters["layout/getIsOpenClose"];
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapState("notificationNavbarStore", ["activeMenuIndex", "openSubMenu"]),
  },
  methods: {
    handleMenuSelect(index, indexPath) {
      const sidebar = document.querySelector('.sidebar-wrapper');
      const savedScrollTop = sidebar ? sidebar.scrollTop : 0;

      // Lưu toàn bộ các submenu cha (bỏ phần tử cuối là menu-item được click)
      const openSubMenuList = (indexPath || []).slice(0, -1);
      this.$store.dispatch("notificationNavbarStore/handleActiveSubmenu", {
        menuIndex: openSubMenuList,
        menuItemIndex: index,
      });

      this.$nextTick(() => {
        if (sidebar) sidebar.scrollTop = savedScrollTop;
      });
    },
    changeBreadcrumbMethod(val) {

      let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
      if (selectUrl.length === 1) {
        let dataList = selectUrl[0].value;
        sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
        this.$store.dispatch("layout/setBreadcrumbActions", dataList);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
  padding: 10px 12px 16px;
  background:
      radial-gradient(circle at top left, rgba(157, 197, 255, 0.28), transparent 28%),
      radial-gradient(circle at 100% 12%, rgba(255, 196, 214, 0.22), transparent 24%),
      linear-gradient(180deg, #f9fbff 0%, #f3f7ff 52%, #eef4fb 100%);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 700px;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  border-right: none !important;
  border-radius: 18px;
  overflow: hidden;
}

/deep/ .el-menu--collapse {
  border-radius: 18px;
  overflow: hidden;
}

.router-link {
  text-decoration: none;
}

.el-menu-item.menu-logo-item {
  background: linear-gradient(135deg, #eef2ff 0%, #e3efff 52%, #f5e8ff 100%) !important;
  border-bottom: 1px solid #d7e3ff !important;
  height: 60px !important;
  line-height: normal !important;
  margin-bottom: 6px;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: linear-gradient(135deg, #e8f0ff 0%, #dbebff 50%, #f0e4ff 100%) !important;
    border-left-color: transparent !important;
  }
}

.menu-logo-icon {
  color: #5b7fd8 !important;
  font-size: 20px !important;
  background: linear-gradient(135deg, rgba(91, 127, 216, 0.16), rgba(173, 114, 255, 0.14));
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/deep/ .el-menu--collapse .menu-logo-icon {
  margin-right: 0 !important;
}

.onekids-title {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  color: #2f436d !important;
  text-transform: uppercase;
}

.el-menu-item {
  background-color: transparent !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  color: #6c7b98 !important;
  border-left: 3px solid transparent !important;
  padding-left: 46px !important;
  border-radius: 10px !important;
  margin: 2px 8px !important;
  transition: all 0.22s ease;

  &:hover {
    background: linear-gradient(90deg, var(--menu-item-hover-start, #f2f7ff) 0%, var(--menu-item-hover-end, #eaf1ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;
  }

  &.is-active {
    background: linear-gradient(90deg, var(--menu-active-start, #dfeaff) 0%, var(--menu-active-end, #d4e2ff) 100%) !important;
    color: #29456f !important;
    border-left: 3px solid var(--menu-accent-strong, #5d83dd) !important;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.12));
  }
}

/deep/ .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #5f6f8f !important;
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 4px 8px;
  transition: all 0.25s ease;

  i {
    color: var(--menu-accent, #7e91b2) !important;
    font-size: 15px;
    margin-right: 8px;
    transition: color 0.2s ease;
  }

  > i:first-child {
    width: 28px;
    height: 28px;
    border-radius: 10px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-accent-soft, rgba(93, 131, 221, 0.12));
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.14));
  }

  &:hover {
    background: linear-gradient(90deg, var(--menu-hover-start, #eff5ff) 0%, var(--menu-hover-end, #e8f0ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;

    i {
      color: var(--menu-accent-strong, #5d83dd) !important;
    }
  }
}

/deep/ .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(90deg, var(--menu-open-start, #edf4ff) 0%, var(--menu-open-end, #e5efff) 100%) !important;
  color: #2f436d !important;
  border-left: 3px solid var(--menu-accent, #6d96f5) !important;

  i {
    color: var(--menu-accent-strong, #5d83dd) !important;
  }
}

/deep/ .el-submenu__icon-arrow {
  color: #8b9aba !important;
  font-size: 11px;
  right: 12px;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
  border: 1px solid #e2eaf7 !important;
  box-shadow: 0 10px 30px rgba(65, 84, 118, 0.08);
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(6px);
}

.menu-group-staff {
  --menu-accent: #a56df5;
  --menu-accent-strong: #8a50e2;
  --menu-accent-soft: rgba(165, 109, 245, 0.15);
  --menu-accent-border: rgba(165, 109, 245, 0.18);
  --menu-hover-start: #f7f0ff;
  --menu-hover-end: #f1e8ff;
  --menu-open-start: #f2e9ff;
  --menu-open-end: #ebddff;
  --menu-item-hover-start: #f7f0ff;
  --menu-item-hover-end: #f0e6ff;
  --menu-active-start: #ece0ff;
  --menu-active-end: #e3d3ff;
}

.menu-group-config {
  --menu-accent: #4bb6c9;
  --menu-accent-strong: #2a9dad;
  --menu-accent-soft: rgba(75, 182, 201, 0.16);
  --menu-accent-border: rgba(75, 182, 201, 0.18);
  --menu-hover-start: #eefbfd;
  --menu-hover-end: #e3f7fa;
  --menu-open-start: #e6f7fb;
  --menu-open-end: #d9f2f7;
  --menu-item-hover-start: #eefbfd;
  --menu-item-hover-end: #e2f6fa;
  --menu-active-start: #d8f0f5;
  --menu-active-end: #caebf2;
}

@media (max-width: 1200px) {
  .menu-main {
    padding: 8px;
  }
}

</style>